// extracted by mini-css-extract-plugin
export const contentContainer = "contact-module--contentContainer--3JPWU";
export const descriptionContainer = "contact-module--descriptionContainer--3GX6Z";
export const socialsContainer = "contact-module--socialsContainer--12RXt";
export const socialLinkContainer = "contact-module--socialLinkContainer--3yW9b";
export const socialLink = "contact-module--socialLink--1qLl6";
export const contactForm = "contact-module--contactForm--3Rha3";